module.exports = __webpack_public_path__ + "static/media/apollo.only.black.b5f2e461.png";